import React from 'react'
import Card from '@mui/material/Card'
import { Avatar, Box, CardContent, Grid, Typography } from '@mui/material'
import Translations from 'src/@core/layouts/components/Translations'
import { AuditingData } from 'src/@types'
import { useTranslation } from 'react-i18next'

interface Props {
  auditingData: AuditingData
}

const CardAuditoria = ({ auditingData }: Props) => {
  const { t } = useTranslation()
  function capitalizeFirstLetter(str: string) {
    if (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1)
    }
  }

  return (
    <>
      {auditingData?.data?.length > 0 ? (
        <Card
          sx={{
            height: '495px',
            boxShadow: 'none',
            padding: '20px',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            borderRadius: '20px',
            backgroundColor: 'white !important'
          }}
        >
          <CardContent
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              gap: 5
            }}
          >
            <Typography
              sx={{ fontSize: '18px', fontWeight: '700', color: 'black', textAlign: 'center' }}
              className='cards-title'
            >
              <Translations text={'Latest tasks'} />
            </Typography>
            <Typography sx={{ fontSize: '14px', textAlign: 'center' }}>
              <Translations text={'Last task was '} />
              {auditingData.lastTask}
              <Translations text={' days ago'} />
            </Typography>
            <Box
              width='100%'
              height='100%'
              justifyContent='space-around'
              alignItems='center'
              display='flex'
              flexDirection='column'
            >
              <Box
                sx={{
                  width: '100%',
                  height: '80px',
                  backgroundColor: '#F1E9DB',
                  borderRadius: '12px',
                  display: 'flex'
                }}
              >
                <Grid
                  container
                  columns={5}
                  sx={{ justifyContent: 'space-between', alignItems: 'center', padding: '15px', width: '97%' }}
                >
                  <Grid item sx={{ width: '25%', textAlign: 'left' }}>
                    <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
                      <Avatar>
                        <Typography>{auditingData?.data[0]?.name?.slice(0, 1).toUpperCase()}</Typography>
                      </Avatar>
                      <Typography>
                        {auditingData?.data[0]?.name.length > 8
                          ? auditingData?.data[0]?.name.slice(0, 8) + '...'
                          : auditingData?.data[0]?.name}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item sx={{ width: '25%', textAlign: 'left', paddingRight: '10px' }}>
                    <Typography>
                      <Translations
                        text={auditingData?.data[0]?.entity ?? capitalizeFirstLetter(auditingData?.data[0]?.entity)}
                      />
                    </Typography>
                  </Grid>
                  <Grid item sx={{ width: '40%', textAlign: 'left' }}>
                    <Typography>
                      {auditingData?.data[0]?.detail?.oldValue
                        ? typeof auditingData?.data[0]?.detail?.oldValue === 'string'
                          ? `${t('oldValue: ')} ${auditingData?.data[0]?.detail?.oldValue} - ${t('newValue: ')} ${
                              auditingData?.data[0]?.detail?.newValue
                            }`
                          : `${t(`Change in ${auditingData?.data[0]?.detail?.propertyName}`)}`
                        : t(auditingData.data[0].detail.entity!)}
                    </Typography>
                  </Grid>
                  <Grid item sx={{ width: '10%', textAlign: 'left' }}>
                    <Typography>{new Date(auditingData?.data[0]?.date).toLocaleDateString()}</Typography>
                  </Grid>
                </Grid>
              </Box>
              {auditingData?.data[1] ? (
                <Box
                  sx={{
                    width: '100%',
                    height: '80px',
                    backgroundColor: '#D8DBE3',
                    borderRadius: '12px',
                    display: 'flex'
                  }}
                >
                  <Grid
                    container
                    columns={5}
                    sx={{ justifyContent: 'space-between', alignItems: 'center', padding: '15px', width: '97%' }}
                  >
                    <Grid item sx={{ width: '25%', textAlign: 'left' }}>
                      <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
                        <Avatar>
                          <Typography>{auditingData?.data[1]?.name?.slice(0, 1).toUpperCase()}</Typography>
                        </Avatar>
                        <Typography>
                          {auditingData?.data[1]?.name.length > 8
                            ? auditingData?.data[1]?.name.slice(0, 8) + '...'
                            : auditingData?.data[1]?.name}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item sx={{ width: '25%', textAlign: 'left', paddingRight: '10px' }}>
                      <Typography>
                        <Translations
                          text={auditingData?.data[1]?.entity ?? capitalizeFirstLetter(auditingData?.data[1]?.entity)}
                        />
                      </Typography>
                    </Grid>
                    <Grid item sx={{ width: '40%', textAlign: 'left' }}>
                      <Typography>
                        {auditingData?.data[1]?.detail?.oldValue
                          ? typeof auditingData?.data[1]?.detail?.oldValue === 'string'
                            ? `${t('oldValue: ')} ${auditingData?.data[1]?.detail?.oldValue} - ${t('newValue: ')} ${
                                auditingData?.data[1]?.detail?.newValue
                              }`
                            : `${t(`Change in ${auditingData?.data[1]?.detail?.propertyName}`)}`
                          : t(auditingData.data[1].detail.entity!)}
                      </Typography>
                    </Grid>
                    <Grid item sx={{ width: '10%', textAlign: 'left' }}>
                      <Typography>{new Date(auditingData?.data[1]?.date).toLocaleDateString()}</Typography>
                    </Grid>
                  </Grid>
                </Box>
              ) : null}
              {auditingData?.data[2] ? (
                <Box
                  sx={{
                    width: '100%',
                    height: '80px',
                    backgroundColor: '#F1E9DB',
                    borderRadius: '12px',
                    display: 'flex'
                  }}
                >
                  <Grid
                    container
                    columns={5}
                    sx={{ justifyContent: 'space-between', alignItems: 'center', padding: '15px', width: '97%' }}
                  >
                    <Grid item sx={{ width: '25%', textAlign: 'left' }}>
                      <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
                        <Avatar>
                          <Typography>{auditingData?.data[2]?.name?.slice(0, 1).toUpperCase()}</Typography>
                        </Avatar>
                        <Typography>
                          {auditingData?.data[2]?.name.length > 8
                            ? auditingData?.data[2]?.name.slice(0, 8) + '...'
                            : auditingData?.data[2]?.name}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item sx={{ width: '25%', textAlign: 'left', paddingRight: '10px' }}>
                      <Typography>
                        <Translations
                          text={auditingData?.data[2]?.entity ?? capitalizeFirstLetter(auditingData?.data[2]?.entity)}
                        />
                      </Typography>
                    </Grid>
                    <Grid item sx={{ width: '40%', textAlign: 'left' }}>
                      <Typography>
                        {auditingData?.data[2]?.detail?.oldValue
                          ? typeof auditingData?.data[2]?.detail?.oldValue === 'string'
                            ? `${t('oldValue: ')} ${auditingData?.data[2]?.detail?.oldValue} - ${t('newValue: ')} ${
                                auditingData?.data[2]?.detail?.newValue
                              }`
                            : `${t(`Change in ${auditingData?.data[2]?.detail?.propertyName}`)}`
                          : t(auditingData.data[2].detail.entity!)}
                      </Typography>
                    </Grid>
                    <Grid item sx={{ width: '10%', textAlign: 'left' }}>
                      <Typography>{new Date(auditingData?.data[2]?.date).toLocaleDateString()}</Typography>
                    </Grid>
                  </Grid>
                </Box>
              ) : null}
            </Box>
          </CardContent>
        </Card>
      ) : null}
    </>
  )
}

export default CardAuditoria
